var r=[];export{r as resizeObservers};
//# sourceMappingURL=resizeObservers.js.map
